import React, { useEffect, useState, useRef, useContext } from "react";
import "../css/viewGame1.css";
import "../css/layout.css";
import { Socket } from "socket.io-client";

import axios from "axios";
import {
  useHistory,
  useLocation,
  NavLink,
  a,
  useNavigate,
} from "react-router-dom";
// import Header from "../Components/Header";
import css from "../css/Pan.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import "../css/Loader.css";
import io from "../Components/socket";
import Compressor from "compressorjs";
import socket from "../Components/socket";
// import { Chip } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";
import WarningSound from "../uiComponents/audio1.mp3";
import WarningSound2 from "../uiComponents/audios.mp3";
import Snake1 from "../uiComponents/snake1.mp3";
import Snake2 from "../uiComponents/snake2.mp3";
import Spinner from "react-bootstrap/Spinner";

import "bootstrap/dist/css/bootstrap.min.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { IoShieldCheckmark } from "react-icons/io5";
import { FaRegCopy } from "react-icons/fa";
// import {useNavigate} from "react-router-dom"

export default function ViewGame1(props) {
  // BASE URL

  // const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  // const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  // const nodeMode = process.env.NODE_ENV;
  // if (nodeMode === "development") {
  //   var baseUrl = beckendLocalApiUrl;
  // } else {
  //   baseUrl = beckendLiveApiUrl;
  // }
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  // +++++++++++++++++++++++++++++

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show_won, setShow_won] = useState(false);
  const handleClose_won = () => setShow_won(false);

  const handleShow_won = () => setShow_won(true);

  const [show_lost, setShow_lost] = useState(false);
  const handleClose_lost = () => setShow_lost(false);

  const handleShow_lost = () => setShow_lost(true);
  const [isChecked, setIsChecked] = useState(false);

  const history = useHistory();

  const location = useLocation();
  const path = location.pathname.split("/")[2];

  const [Game, setGame] = useState("0");
  // console.log(Game);
  const [status, setStatus] = useState(null);

  const [fecthStatus, setFecthStatus] = useState();
  const [scrnshot, setScrnshot] = useState(null);
  const [scrnshot1, setScrnshot1] = useState(""); // ADDED BY TEAM
  const [initialRoom, setInitialRoom] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [isLoading1, setIsloading1] = useState(false);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [reason, setReason] = useState(null);

  const [roomcode, setRoomcode] = useState();
  let submitReq = useRef(false);
  const isMounted = useRef(true);

  const [submitProcess, setProcess] = useState(true);
  const handleChangeCheckbox = () => {
    setIsChecked(!isChecked);
  };

  /// user details start
  const [user, setUser] = useState();
  const [userAllData, setUserAllData] = useState();
  const [showBackDiv, setShowBackDiv] = useState(false); // Step 1

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    Allgames(userId);
    setUser(userId);
    // setUserAllData(res.data);
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      history.push("/login");
    }

    // role();
  }, []);
  useEffect(() => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    Allgames(userId);
    setUser(userId);
    // setUserAllData(res.data);
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      history.push("/login");
    }

    // role();
  }, [props.userData]);

  useEffect(() => {
    io.on("updateroomcode", (data) => {
      // Allgames(userId);
      // setStopCountdown(true);
      let userId = localStorage.getItem("userId");

      if (data?.Accepetd_By?._id == userId) {
        setInitialRoom(data);
        setGame(data);
      }
    });
  }, [initialRoom.Room_code == 0]);

  const handleReason1 = () => {
    setStatus("cancelled");
    setReason("No Room code");
  };
  const handleReason2 = () => {
    setReason("Not joined");
    setStatus("cancelled");
  };
  const handleReason3 = () => {
    setReason("Not Playing");
    setStatus("cancelled");
  };
  const handleReason4 = () => {
    setReason("Dont want to play");
    setStatus("cancelled");
  };
  const handleReason5 = () => {
    setReason("Opponent Abusing");
    setStatus("cancelled");
  };
  const handleReason6 = () => {
    setReason("Game not Started");
    setStatus("cancelled");
  };
  const handleReasoneChange = (e) => {
    setReason(e.target.value);
  };

  const getRoomCode = async () => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(`challange/roomcode/${path}`, "PATCH", { Room_code: roomcode }, headers);

    setIsloading1(false);
    setShowBackDiv(true); // Step 2 - Show the div after response

    if (res.data?.status == false) {
      Swal.fire({
        title: res.data.msg,
        icon: "warning",
        confirmButtonText: "OK",
      });
    } else {
      setGame(res.data);
    }
  };

  /// user details end
  const [ALL, setALL] = useState();

  const Allgames = async (userId) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    // await axios
    //   .get(baseUrl + `challange/${path}`, { headers })

    const res = await apiRequest(`challange/${path}`, "GET", null, headers)
    // .then((res) => {
    if (res.data?.status == false) {
      Swal.fire({
        title: res.data.msg,
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    if (res.data?.Status == "new" || res.data.Status == "requested") {
      setTimeout(async () => {
        // await axios
        //   .get(baseUrl + `challange/${path}`, {
        //     headers,
        //   })

        const res = await apiRequest(`challange/${path}`, "GET", null, headers)
        // .then((res) => {
        if (
          res.data.Status == "new" ||
          res.data.Status == "requested"
        ) {
          history.push(props?.location?.state?.prevPath);
        } else {
          setProcess(false);
        }
        // })
        // .catch((error) => {
        //   console.error(error);
        //   history.push(props?.location?.state?.prevPath);
        // });
      }, 10000);
    } else {
      setProcess(false);
    }
    setALL(res.data);
    setGame(res.data);

    if (userId == res.data.Accepetd_By._id) {
      setFecthStatus(res.data.Acceptor_status);
    }

    if (userId == res.data.Created_by._id) {
      setFecthStatus(res.data.Creator_Status);
    }
    // })
    // .catch((e) => {
    //   if (e.response?.status == 401) {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("token");
    //     window.location.reload();
    //     history.push("/login");
    //   }
    // });
  };
  // -----Start timer ------------------------------------------------------------------------
  const [showDiv, setShowDiv] = useState(true);
  const [secondsRemaining, setSecondsRemaining] = useState(null);

  // Replace this with the actual timestamp from MongoDB
  const createdAtTimestamp = new Date(Game.createdAt).getTime(); // Example timestamp

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const currentTime = new Date().getTime();
      const differenceInSeconds = Math.floor(
        (currentTime - createdAtTimestamp) / 1000
      );
      //  console.log(differenceInSeconds,showDiv)
      if (differenceInSeconds >= 240) {
        setShowDiv(false);
      } else {
        setSecondsRemaining(240 - differenceInSeconds);
      }
    };

    calculateTimeRemaining(); // Calculate initial time remaining

    // Update time remaining every second
    const timer = setInterval(() => {
      calculateTimeRemaining();
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [createdAtTimestamp]);

  // -----end timer------

  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
    setStatus(null);
  };
  // Result
  const Suggestion = (e) => {
    alert("ok");
  };
  const Result = async (e) => {
    e.preventDefault();

    if (submitReq.current == false) {
      submitReq.current = true;
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      if (status) {
        setProcess(true);
        const formData = new FormData();
        if (scrnshot != null) {
          formData.append("file", scrnshot);
        }
        formData.append("status", status);
        if (status == "cancelled") {
          formData.append("reason", reason);
        }

        // await axios({
        //   method: "post",
        //   url: baseUrl + `challange/result/${path}`,
        //   data: formData,
        //   headers: headers,
        // })

        const res = await apiRequest(`challange/result/${path}`, "POST", formData, headers)
        // .then((res) => {
        // console.log(res,'res')
        if (res.data?.status == false) {
          submitReq.current = false;
          setProcess(false);
          Swal.fire({
            position: "center",
            icon: "error",
            type: "error",
            title: res.data.msg,
            showConfirmButton: true,
          });
        } else {
          io.emit("resultAPIdata", path);
          // console.log(path, "id")
          submitReq.current = false;
          setProcess(false);
          history.push(props?.location?.state?.prevPath);
        }
        // })
        // .catch((e) => {
        //   console.log(e, "e error msg q");
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: e.message,
        //   });
        //   {
        //     console.log(e.message);
        //   }
        //   if (e.response?.status == 401) {
        //     localStorage.removeItem("token");
        //     localStorage?.removeItem("token");
        //     window?.location?.reload();
        //     history.push("/login");
        //   }
        // });
      } else {
        submitReq.current = false;
        alert("please fill all field or Re-Select result status");
      }
    }
  };

  const copyCode = (e) => {
    navigator.clipboard.writeText(Game.Room_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Room Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const Completionist = () => <span>You are good to go!</span>;

  // ADDED BY TEAM
  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      console.log(" compression");
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };
  // cancel button active function
  $(document).ready(function () {
    $(".cancel_reason_btns_bg").click(function () {
      $(".cancel_reason_btns_bg").removeClass("nav_active");
      $(this).addClass("nav_active");
    });
  });

  const handleSetRoomCode = () => {
    const inputValue = roomcode;
    if (Game.Game_type !== "LudoSnake") {
      if (
        /^[0-9]+$/.test(inputValue) &&
        inputValue.length === 8 &&
        inputValue[0] === "0"
      ) {
        getRoomCode();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please enter a valid 8-digit code that starts with 0.",
          showConfirmButton: true,
        });
      }
    } else {
      getRoomCode();
    }
  };

  function winnAmount(gameAmount) {
    let profit = null;
    // {console.log(addCaseSetting?.commissionRange2)}
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  // language
  const translations = {
    hi: {
      back: "पीछे जाये",
      code: "कोड कॉपी करे",
      roomcode: "रूम कोड सेट करें",
      rule: "खेल के नियम",
      status: "खेल का परिणाम ",
      won: "मैं जीता",
      loss: "में हारा ",
      cancel: "रद्द ",
    },
    en: {
      back: "Back",
      code: "Copy Code",
      roomcode: " Set Room Code",
      rule: "game rule",
      status: "Match Status",
      won: "i Won",
      loss: "i Lost",
      cancel: "Cancel ",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");
  const styles = {
    backgroundColor: theme === "light" ? "#d3e3fd" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    backgroundColor: theme === "light" ? "#fff" : "#27241b",
    color: theme === "light" ? "black" : "#fff",
  };

  const styles2 = {
    backgroundColor: theme === "light" ? "#facc06" : "#27241b",
    color: theme === "light" ? "black" : "#fff",
  };


  useEffect(() => {
    io.on("notify", (data) => {
      console.log(data.GameID, "io", path,)
      if (data.GameID == path) {
        Swal.fire({
          title: data.msg,
          icon: "success",
          confirmButtonText: "OK",
        });
        history.push("/Homepage/ludoClassicManual");
      }
    });
  }, [Socket])

  return (
    <>
      {Game && (
        <div className="room_code_main_page" >
          <div>

            {/* =========message======== */}
            {Game.Game_type === "ludoClassicManual" ? (
              <div className="ml_notice_card">


                <div className="ml_notice_content">
                  <p>
                    {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.roomCodePageMsg}

                  </p>
                </div>

                <div className="ml_notice_speaker">
                  <img
                    src="https://cdn-icons-png.flaticon.com/128/7152/7152226.png"
                    alt="speaker"
                  />
                </div>
              </div>
            ) : (
              <div className="ml_notice_card">

                <div className="ml_notice_content">
                  <p>
                    {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.ludoClassicAutobattleMsg}
                  </p>
                </div>

                <div className="ml_notice_speaker">
                  <img
                    src="https://cdn-icons-png.flaticon.com/128/7152/7152226.png"
                    alt="speaker"
                  />
                </div>
              </div>
            )}

            <div className="" >

              {/* =========Back button============ */}
              <div className="viewgame_topbtn">

                <NavLink
                  to="/landing"
                  className="ml_back_btn"
                >
                  <ArrowBackIcon className="ml_back_icon" />

                  <span>
                    {translations[language].back}
                  </span>

                </NavLink>

              </div>
              {!Boolean(submitProcess) && (
                <div className="" >
                  <div className="">
                    <div className="rb_vs_card">

                      <div className="rb_vs_left">

                        <div className="rb_vs_user">
                          {Game?.Created_by?.avatar ? (
                            <img
                              src={baseUrl + `/${Game.Created_by?.avatar}`}
                              className="rb_vs_avatar"
                              alt=""
                            />
                          ) : (
                            <img
                              src="/images/avatars/Avatar2.png"
                              className="rb_vs_avatar"
                              alt=""
                            />
                          )}

                          <div>
                            <div className="rb_vs_name">
                              {Game.Created_by?.Name.length > 8
                                ? `${Game.Created_by?.Name.slice(0, 8)}...`
                                : Game.Created_by?.Name}
                            </div>

                            <div className="rb_vs_label">
                              ENTRY FEE
                            </div>

                            <div className="rb_vs_amount">
                              <img src="/images/rupee1.png" alt="" />
                              <span>{Game.Game_Ammount}</span>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="rb_vs_center">
                        <img
                          src="/images/VS-image.png"
                          className="rb_vs_center_img"
                          alt=""
                        />
                      </div>

                      <div className="rb_vs_right">

                        <div className="rb_vs_user">

                          {Game?.Accepetd_By?.avatar ? (
                            <img
                              src={baseUrl + `/${Game.Accepetd_By.avatar}`}
                              className="rb_vs_avatar"
                              alt=""
                            />
                          ) : (
                            <img
                              src="/images/avatars/Avatar2.png"
                              className="rb_vs_avatar"
                              alt=""
                            />
                          )}

                          <div>
                            <div className="rb_vs_name">
                              {Game.Accepetd_By?.Name.length > 8
                                ? `${Game.Accepetd_By?.Name.slice(0, 8)}...`
                                : Game.Accepetd_By?.Name}
                            </div>

                            <div className="rb_vs_win_label">
                              WINNING PRIZE
                            </div>

                            <div className="rb_vs_amount">
                              <img src="/images/rupee1.png" alt="" />
                              <span>
                                {Game.Game_Ammount +
                                  winnAmount(Game?.Game_Ammount)}
                              </span>
                            </div>
                          </div>

                        </div>

                      </div>

                    </div>

                    {/* <div className='thin-divider-x ' /> */}
                    <div className="mb-3"  >
                      {(Game.Room_code == null && (
                        <div className="rb_wait_card">

                          <div className="rb_wait_badge">
                            <span>⏳ WAITING FOR ROOM CODE</span>
                          </div>

                          <div className="rb_wait_content">

                            <img
                              src="/images/dice-red.png"
                              className="rb_wait_dice rb_wait_dice_left"
                              alt=""
                            />

                            <div className="rb_wait_center">

                              <h3 className="rb_wait_title">
                                Waiting for Room Code...
                              </h3>

                              <h4 className="rb_wait_subtitle">
                                रूम कोड का इंतजार है।
                              </h4>

                              <div className="rb_wait_loader">
                                <div className="lds-spinner">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>

                            </div>

                            <img
                              src="/images/dice-purple.png"
                              className="rb_wait_dice rb_wait_dice_right"
                              alt=""
                            />

                          </div>

                        </div>
                      )) ||
                        (Game.Room_code != "0" && (
                          <div className="rb_room_card">

                            <div className="rb_room_header">

                              <div className="rb_room_status">
                                ✅ ROOM ID CREATED
                              </div>

                            </div>

                            <div className="rb_room_code_box">

                              <h2 className="rb_room_code">
                                {Game.Room_code}
                              </h2>

                            </div>

                            <button
                              className="rb_copy_btn"
                              onClick={(e) => copyCode(e)}
                            >
                              {translations[language].code}
                            </button>

                          </div>
                        )) ||
                        (Game.Room_code == "0" &&
                          ((Game.Created_by._id == user &&
                            Game.Room_code == "0" && (
                              <div className="rb_upload_card">

                                <div className="rb_upload_header">
                                  🎮 ROOM CODE UPLOAD
                                </div>

                                {showDiv && (
                                  <>

                                    {/* <h3 className="rb_upload_title">
                                      लूडो किंग से रूम कोड अपलोड करें
                                    </h3> */}

                                    <div className="rb_timer_box">
                                      <span className="rb_timer_value">
                                        {secondsRemaining} Seconds
                                      </span>

                                    </div>

                                    <div className="rb_input_label">
                                      Enter Room Code
                                    </div>

                                    <div className="rb_input_wrapper">

                                      <input
                                        type="number"
                                        placeholder="Room Code"
                                        value={roomcode}
                                        onChange={(e) => setRoomcode(e.target.value)}
                                        className="rb_room_input"
                                      />

                                      {isLoading1 ? (
                                        <button
                                          className="rb_set_btn rb_set_btn_loading"
                                          disabled
                                        >
                                          <span className="rb_btn_loader"></span>
                                          Setting...
                                        </button>
                                      ) : (
                                        <button
                                          className="rb_set_btn"
                                          onClick={handleSetRoomCode}
                                        >
                                          <span className="rb_btn_shine"></span>
                                          Set
                                        </button>
                                      )}

                                    </div>

                                  </>
                                )}

                                <div className="rb_marquee_box">
                                  <marquee>
                                    कृपया लूडो किंग से रूम कोड निकाल कर
                                    SET ROOM CODE में डाल दें
                                  </marquee>
                                </div>

                              </div>
                            )) ||
                            (Game.Accepetd_By._id == user &&
                              Game?.Room_code == "0" && (
                                <div className="rb_opponent_wait_card">

                                  {showDiv ? (

                                    <div className="rb_opponent_wait_content">

                                      <div className="rb_opponent_badge">
                                        ⏳ WAITING FOR ROOM CODE
                                      </div>

                                      {/* <h3 className="rb_opponent_title">
                                        Waiting for Room Code
                                      </h3>

                                      <h4 className="rb_opponent_subtitle">
                                        रूम कोड का इंतजार है।
                                      </h4> */}

                                      <div className="rb_opponent_timer">
                                        {secondsRemaining} Seconds
                                      </div>

                                      <div className="rb_premium_loader">

                                        <div className="rb_loader_ring"></div>

                                        <img
                                          src="/images/rupee1.png"
                                          alt=""
                                          className="rb_loader_coin"
                                        />

                                      </div>

                                    </div>

                                  ) : (

                                    <div className="rb_opponent_timeout">
                                      Waiting For Room Code
                                    </div>

                                  )}

                                  <div className="rb_opponent_notice">
                                    <marquee>
                                      कृपया इंतजार करे सामने वाला यूजर
                                      लूडो किंग से रूम कोड निकाल कर दे रहा है
                                    </marquee>
                                  </div>

                                </div>
                              ))))}
                    </div>

                    <div className="rb_match_status_wrapper">
                      <div className="rb_match_status_heading">

                        <span className="rb_status_line"></span>

                        <div className="rb_status_title">
                          Match Status
                        </div>

                        <span className="rb_status_line"></span>

                      </div>
                      <form
                        className="result-area"
                        onSubmit={(e) => {
                          Result(e);
                        }}
                        encType="multipart/form-data"
                      >
                        {fecthStatus !== null && fecthStatus !== undefined && (
                          <div className="battle_result_updated_card">

                            <div className="battle_result_updated_icon">
                              ✓
                            </div>

                            <div className="battle_result_updated_content">

                              <div className="battle_result_updated_title">
                                Result Already Submitted
                              </div>

                              <div className="battle_result_updated_text">
                                You have already updated your battle result as

                                <span className="battle_result_status_badge">
                                  {fecthStatus}
                                </span>
                              </div>

                            </div>

                          </div>
                        )}
                        {fecthStatus === null && (
                          <>

                            <div
                              className="premium_result_buttons"
                              role="radiogroup"
                              aria-label="Result"
                            >

                              {Game.Room_code != "0" && (
                                <>
                                  {/* WIN */}

                                  <label className="premium_result_btn premium_btn_win">
                                    <input
                                      name="battleResult"
                                      type="radio"
                                      value="winn"
                                      onClick={() => {
                                        setStatus("winn");
                                        handleShow_won();
                                      }}
                                    />

                                    <div className="premium_btn_content">
                                      <span className="premium_btn_icon">🏆</span>
                                      <span>{translations[language].won}</span>
                                    </div>
                                  </label>

                                  {/* LOST */}

                                  <label className="premium_result_btn premium_btn_lost">
                                    <input
                                      name="battleResult"
                                      type="radio"
                                      value="lose"
                                      onClick={() => {
                                        setStatus("lose");
                                        handleShow_lost();
                                      }}
                                    />

                                    <div className="premium_btn_content">
                                      <span className="premium_btn_icon">☹</span>
                                      <span>{translations[language].loss}</span>
                                    </div>
                                  </label>
                                </>
                              )}

                              {/* CANCEL */}

                              <label className="premium_result_btn premium_btn_cancel">
                                <input
                                  name="battleResult"
                                  type="radio"
                                  value="cancelled"
                                  onClick={() => {
                                    setStatus("cancelled");
                                    handleShow();
                                  }}
                                />

                                <div className="premium_btn_content">
                                  <span className="premium_btn_icon">✖</span>
                                  <span>{translations[language].cancel}</span>
                                </div>
                              </label>

                            </div>
                          </>
                        )}

                        {/* ================================= */}
                        {/* ========cancel model============ */}
                        {/* ================================= */}

                        <section className="game_result_submit_model">
                          <Modal
                            show={show}
                            onHide={handleClose}
                            className="cancel_popup_reason_popup cls"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <Modal.Header closeButton className="premium_cancel_header">
                              <h2 className="premium_cancel_title">
                                We would like to know more
                              </h2>
                            </Modal.Header>

                            <Modal.Body className="premium_cancel_body">

                              <div className="premium_cancel_subtitle">
                                Select Reason for cancelling
                              </div>

                              {status === "cancelled" && (

                                <div className="premium_reason_grid">

                                  <div
                                    className={`premium_reason_card ${selectedReason === "No Room code" ? "active" : ""}`}
                                    onClick={() => {
                                      setSelectedReason("No Room code");
                                      setShowInput(false);
                                      handleReason1();
                                    }}
                                  >
                                    <span>🔲</span>
                                    <span>No Room code</span>
                                  </div>

                                  <div
                                    className={`premium_reason_card premium_pink ${selectedReason === "Not Joined" ? "active" : ""}`}
                                    onClick={() => {
                                      setSelectedReason("Not Joined");
                                      setShowInput(false);
                                      handleReason2();
                                    }}
                                  >
                                    <span>👤</span>
                                    <span>Not joined</span>
                                  </div>

                                  <div
                                    className={`premium_reason_card ${selectedReason === "Not Playing" ? "active" : ""}`}
                                    onClick={() => {
                                      setSelectedReason("Not Playing");
                                      setShowInput(false);
                                      handleReason3();
                                    }}
                                  >
                                    <span>🎮</span>
                                    <span>Not Playing</span>
                                  </div>

                                  <div
                                    className={`premium_reason_card premium_pink ${selectedReason === "Dont Want Play" ? "active" : ""}`}
                                    onClick={() => {
                                      setSelectedReason("Dont Want Play");
                                      setShowInput(false);
                                      handleReason4();
                                    }}
                                  >
                                    <span>❌</span>
                                    <span>Dont Want to Play</span>
                                  </div>

                                  <div
                                    className={`premium_reason_card ${selectedReason === "Opponent Abusing" ? "active" : ""}`}
                                    onClick={() => {
                                      setSelectedReason("Opponent Abusing");
                                      setShowInput(false);
                                      handleReason5();
                                    }}
                                  >
                                    <span>🛡️</span>
                                    <span>Opponent Abusing</span>
                                  </div>

                                  <div
                                    className={`premium_reason_card premium_pink ${selectedReason === "Game Not Started" ? "active" : ""}`}
                                    onClick={() => {
                                      setSelectedReason("Game Not Started");
                                      setShowInput(false);
                                      handleReason6();
                                    }}
                                  >
                                    <span>🕒</span>
                                    <span>Game not Started</span>
                                  </div>

                                  <div
                                    className="premium_reason_card premium_reason_full"
                                    onClick={() => {
                                      setShowInput(true);
                                    }}
                                  >
                                    <span>•••</span>
                                    <span>Others</span>
                                  </div>

                                </div>
                              )}

                              {showInput && (
                                <textarea
                                  className="premium_reason_textarea"
                                  placeholder="Write your reason..."
                                  onChange={(e) => {
                                    setReason(e.target.value);
                                  }}
                                />
                              )}

                              <button
                                className="premium_submit_btn"
                                onClick={(e) => {
                                  if (selectedReason) {
                                    Result(e);
                                  } else {
                                    Swal.fire({
                                      position: "center",
                                      icon: "error",
                                      title: "Please Select Reason",
                                      showConfirmButton: true,
                                    });
                                  }
                                }}
                              >
                                Submit →
                              </button>

                            </Modal.Body>

                          </Modal>
                        </section>

                        {/* ================================= */}
                        {/* ========WON model============ */}
                        {/* ================================= */}

                        <section className="win_modal ">
                          <Modal
                            show={show_won}
                            onHide={handleClose_won}
                            className="cancel_popup_reason_popup upload_result"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <Modal.Header closeButton>

                              <div className="model_header">
                                <h3>Upload Result</h3>
                              </div>
                            </Modal.Header>
                            <Modal.Body className="win_upload_modal_body">

                              <div className="upload_result_badge">
                                UPLOAD RESULT
                              </div>

                              {/* <div className="win_upload_icon_wrap">
                                <img
                                  src="/images/uploading.png"
                                  alt=""
                                  className="win_upload_trophy"
                                />
                              </div> */}

                              <h2 className="win_upload_title">
                                Proof of Victory
                              </h2>

                              <p className="win_upload_subtitle">
                                Upload your screenshot to claim your win
                              </p>

                              {status !== null &&
                                status !== "cancelled" &&
                                status !== "lose" && (

                                  <div className="win_upload_area">

                                    <input
                                      type="file"
                                      onChange={handleChange}
                                      accept="image/*"
                                      required
                                      className="win_upload_input"
                                    />

                                    {!scrnshot ? (

                                      <div className="win_upload_placeholder">

                                        <div className="win_upload_icon">
                                          📷
                                        </div>

                                        <h4>Add Image</h4>

                                        <p>Tap to upload screenshot</p>

                                      </div>

                                    ) : (

                                      <div className="win_uploaded_file">

                                        <img
                                          src="/images/file-icon.png"
                                          alt=""
                                          className="win_file_icon"
                                        />

                                        <div className="win_file_info">

                                          <div className="win_file_name">
                                            {scrnshot.name}
                                          </div>

                                          <div className="win_file_size">
                                            {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
                                          </div>

                                        </div>

                                        <button
                                          type="button"
                                          className="win_file_remove"
                                          onClick={() => {
                                            clearImage();
                                            handleClose_won();
                                          }}
                                        >
                                          ✕
                                        </button>

                                      </div>

                                    )}

                                  </div>
                                )}

                              {fecthStatus == null &&
                                fecthStatus == undefined && (

                                  <button
                                    className="win_submit_btn"
                                    onClick={(e) => {
                                      Result(e);
                                    }}
                                    disabled={!scrnshot}
                                  >
                                    {scrnshot ? "POST SUBMIT" : "SELECT FILE FIRST"}
                                  </button>

                                )}

                            </Modal.Body>
                          </Modal>
                        </section>

                        {/* ================================= */}
                        {/* ========lost model============ */}
                        {/* ================================= */}

                        <section className="">
                          <Modal
                            show={show_lost}
                            onHide={handleClose_lost}
                            className="cancel_popup_reason_popup "
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <Modal.Header closeButton className="lost_modal_header">
                            </Modal.Header>
                            <Modal.Body className="lost_game_modal_body">

                              <div className="lost_game_top_glow"></div>

                              <h2 className="lost_game_title">
                                Are you sure you Lost this game?
                              </h2>

                              <div className="lost_game_divider">
                                <span></span>
                              </div>

                              <h4 className="lost_game_hindi">
                                क्या आप निश्चित हैं कि आप यह गेम हार गए हैं?
                              </h4>

                              <div className="lost_confirm_wrapper">

                                <label className="lost_confirm_card">

                                  <input
                                    type="checkbox"
                                    id="loast"
                                    name="loast"
                                    value="Yes, lost"
                                    checked={isChecked}
                                    onChange={handleChangeCheckbox}
                                  />

                                  <span className="lost_custom_checkbox"></span>

                                  <span className="lost_confirm_text">
                                    Yes, I Confirm
                                  </span>

                                </label>

                              </div>

                              <div className="lost_action_buttons">

                                {fecthStatus == null &&
                                  fecthStatus == undefined && (

                                    <button
                                      disabled={!isChecked}
                                      className={`lost_yes_btn ${!isChecked ? "disabled_btn" : ""}`}
                                      onClick={(e) => {
                                        Result(e);
                                      }}
                                    >
                                      <span className="lost_btn_icon">💔</span>
                                      <span>YES, I LOST</span>
                                    </button>
                                  )}

                                <button
                                  onClick={handleClose_lost}
                                  className="lost_no_btn"
                                >
                                  <span className="lost_btn_icon">✕</span>
                                  <span>No</span>
                                </button>

                              </div>

                            </Modal.Body>
                          </Modal>
                        </section>
                      </form>
                    </div>

                    {Game.Game_type === "LudoPrime" ? (
                      <div className="game_app_card">

                        <div className="game_app_title">
                          Play Ludo Game in Prime Ludo App
                        </div>

                        <a
                          href="https://primeludo.in/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="game_app_link"
                        >
                          <div className="game_app_box">

                            <img
                              className="game_app_logo"
                              src="/mainimage/primeLudo.jpg"
                              alt="Prime Ludo"
                            />

                            <div className="game_app_info">
                              <h4>Prime Ludo</h4>
                              <span>Open & Play Match</span>
                            </div>

                            <div className="game_app_btn">
                              OPEN
                            </div>

                          </div>
                        </a>

                      </div>
                    ) : (
                      <div className="game_app_card">

                        <div className="game_app_title">
                          Play Ludo Game in Ludo King App
                        </div>

                        <a
                          href="https://ludokingnew.page.link/FPqXbMi3W7tAvj5t9"
                          target="_blank"
                          rel="noreferrer"
                          className="game_app_link"
                        >
                          <div className="game_app_box">

                            <img
                              className="game_app_logo"
                              src="/Ludo_King_Logo.webp.png"
                              alt="Ludo King"
                            />

                            <div className="game_app_info">
                              <h4>Ludo King</h4>
                              <span>Open & Play Match</span>
                            </div>

                            <div className="game_app_btn">
                              OPEN
                            </div>

                          </div>
                        </a>

                      </div>
                    )}

                  </div>
                </div>
              )}
            </div>
            {Boolean(submitProcess) && (
              <div className="loaderReturn" style={{ zIndex: "99" }}>
                <img
                  src={"/images/LandingPage_img/loader1.gif"}
                  style={{ width: "20%" }}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div class="divider-y"></div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
